export default {
  name: 'PcLayoutContainer',
  data() {
    return {
      className: 'app__layout-container',
    };
  },
  props: {
    size: {
      type: String,
      default: 'small',
    },
    theme: {
      type: String,
      default: 'light',
    },
  },
  computed: {
    sizeClassName() {
      return `${this.className}--${this.size}`;
    },
    themeClassName() {
      return `${this.className}--${this.theme}`;
    },
  },
};
